'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AdWrapper = require('../../AdWrapper');

var _AdWrapper2 = _interopRequireDefault(_AdWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * FWAd companion ad component
 * @param {Object} props the component props
 * @returns {XML}
 * @constructor
 */
var FWAd = function FWAd(props) {
  return _react2.default.createElement(
    _AdWrapper2.default,
    null,
    _react2.default.createElement(
      'span',
      { id: 'videocompanion', className: '_fwph' },
      _react2.default.createElement(
        'form',
        { id: '_fw_form_videocompanion', style: { display: 'none' } },
        _react2.default.createElement('input', {
          type: 'hidden',
          name: '_fw_input_videocompanion',
          id: '_fw_input_videocompanion',
          value: props.adSetting
        })
      ),
      _react2.default.createElement('span', { id: '_fw_container_videocompanion', className: '_fwac ' })
    )
  );
};

/**
 * propTypes
 * @type {{adSetting: *}}
 */
exports.default = FWAd;


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/components/ads/fw/Companion/FWAd.js
// module id = 116
// module chunks = 35783957827783 71851226274881